import React from 'react';
import { withRouter } from 'react-router-dom';
import { Query, withApollo } from "react-apollo";

import { commentFeed } from '../../graphql/queries';
import { ColError, ColLoading, ColumnFeed } from '../chunk';
import { CommentList } from "../comment";
import { PostAdd }  from "../post";
import { ChannelHead } from '../channel';


class CommentFeed extends React.Component {

	/*constructor(props) {

		super(props);
		
		this.state = {
			cursor: ''
		}
	}*/

	render() {

		return (
		
			<Query 
				query={commentFeed} 
				variables={{ 
					filter: { channel: this.props.channelId }, 
					cursor: ''
				}}
				fetchPolicy="cache-and-network">

				{({ loading, error, data, fetchMore }) => {

				if(!data || !data.commentFeed || !data.commentFeed.comments) {
					if( loading ) return (<div className="col col-2"><ColLoading /></div>);
					if( error ) return (<div className="col col-2"><ColError error={error} /></div>);
				}
				
				return (
				
					<ColumnFeed className="col-primary" onReachBottom={() => {

						fetchMore({
							query: commentFeed,
							variables: { 
								filter: { channel: this.props.channelId }, 
								cursor: data.commentFeed.cursor
							},
							updateQuery: (previousResult, { fetchMoreResult }) => {
								const prevComments = previousResult.commentFeed.comments;
								const newComments = fetchMoreResult.commentFeed.comments;
								const newCursor = fetchMoreResult.commentFeed.cursor;
					
								return {
									commentFeed: {
										__typename: 'CommentFeed',
										cursor: newCursor,
										comments: [...prevComments, ...newComments]
									}
								};
							}
						})
					}}>
					
						<ChannelHead channelId={this.props.channelId} />
						<PostAdd className="post-add--top" attachments channel={this.props.channelId} />

						{data && data.commentFeed && <CommentList comments={data.commentFeed.comments} />}

					</ColumnFeed>
				)}}
			</Query>
		)
	}
}

export default withApollo(withRouter(CommentFeed))


// WEBPACK FOOTER //
// ./src/components/comment/CommentFeed.js